exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ANQI9ksecwIeSI8zxCVoi{border-bottom:.07143rem solid #ccc}.QQsxC3ktgoU9HBULR5CNM{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;cursor:pointer;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;padding:1.78571rem}.QQsxC3ktgoU9HBULR5CNM._1MyG94e6RV5lFzLmR5c88p{border-bottom:.07143rem solid #ccc}._29CaDFMWKz6Sd7FpXWrzz_{display:-webkit-inline-box;display:-webkit-inline-flex;display:-moz-inline-box;display:-ms-inline-flexbox;display:inline-flex;font-size:1.125em;font-weight:600;margin-right:1.42857rem}._3Xh4nLMWUsw2IX5nc-Zm8I{margin-right:1.42857rem}._3Xh4nLMWUsw2IX5nc-Zm8I,._3Xh4nLMWUsw2IX5nc-Zm8I._1MyG94e6RV5lFzLmR5c88p{-webkit-transition-duration:.5s;-moz-transition-duration:.5s;-o-transition-duration:.5s;transition-duration:.5s}._3Xh4nLMWUsw2IX5nc-Zm8I._1MyG94e6RV5lFzLmR5c88p{-webkit-transform:rotate(90deg);-moz-transform:rotate(90deg);-ms-transform:rotate(90deg);-o-transform:rotate(90deg);transform:rotate(90deg)}._2q3mGkm5Adsd87Yh-qRrg8{color:#a4a4a4}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"ExpansionGridItem": "ANQI9ksecwIeSI8zxCVoi",
	"ExpansionGridItem_header": "QQsxC3ktgoU9HBULR5CNM",
	"__expanded": "_1MyG94e6RV5lFzLmR5c88p",
	"ExpansionGridItem_header_title": "_29CaDFMWKz6Sd7FpXWrzz_",
	"ExpansionGridItem_header_icon": "_3Xh4nLMWUsw2IX5nc-Zm8I",
	"ExpansionGridItem_header_summary": "_2q3mGkm5Adsd87Yh-qRrg8"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/build-omni-operation-ui_develop/node_modules/omni-common-ui/postcss.config.js"}}!./components/ExpansionGridItem/style.postcss
// module id = 1326
// module chunks = 0